module.exports = __webpack_public_path__ + "img/payment-apply.44fed1a5.svg";